<ng-container *ngIf="columns === 3">
    <div class="shop-layout shop-layout--sidebar--{{ sidebarPosition }}">
   <!--      <app-widget-advanced-search *ngIf="advancedSearch" [offcanvas]="advancedSearch.offcanvas" [companyId]="advancedSearch.companyId" [type]="advancedSearch.type" [searchInfo]="advancedSearch.searchInfo" [subtypeId]="advancedSearch.subtypeId" offcanvas="always"></app-widget-advanced-search> -->

        <div class="shop-layout__sidebar"  >
            <app-shop-sidebar  offcanvas="mobile"></app-shop-sidebar>
        </div>

        <div *ngIf="products?.length > 0 || categoryData?.sucategories?.length > 0; else noProducts" class="{{showSidebar=='true'?'shop-layout__content':'shop-layout__content_full'}}">
            <div class="block">
                <!-- <app-block-subcategories-carousel *ngIf="categoryData?.subCategories?.length > 0 || parent" [parent]="parent" [subcategories]="categoryData?.subCategories"></app-block-subcategories-carousel> -->
                <!-- <app-block-mobile-subcategories *ngIf="categoryData?.subCategories?.length > 0 || parent" [parent]="parent" [subcategories]="categoryData?.subCategories"></app-block-mobile-subcategories> -->
                <!-- <app-subcategories-carousel *ngIf="categoryData?.subCategories?.length > 0 || parent"
                    [parent]="parent" [subcategories]="categoryData?.subCategories">
                </app-subcategories-carousel> -->
                <!-- <app-products-view *ngIf="products"  
                    [productsCount]="productsCount" [products]="products" [layout]="viewMode" grid="grid-4-full"
                    offcanvas="mobile"></app-products-view> -->

                <app-products-view *ngIf="products && view" [itemsView]="view" [productsCount]="productsCount" [products]="products" [layout]="viewMode" offcanvas="mobile"></app-products-view>
            </div>
        </div>

        <ng-template #noProducts>
            <div class="container">
                <div class="empty-state">
                    <img src="/assets/svg/empty_state.svg">
                    <h4 class="mt-4">Selected Category has No Products.</h4>
                </div>
            </div>
        </ng-template>

        <div class="shop-layout__sidebar" *ngIf="showSidebar == 'true' && sidebarPosition === 'end'">
            <app-shop-sidebar offcanvas="mobile"></app-shop-sidebar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="columns > 3">
    <div class="container">
        <div class="block" *ngIf="products?.length > 0 || categoryData?.sucategories?.length > 0;">
            <!-- <app-products-view [layout]="viewMode" [grid]="'grid-'+columns+'-full'" offcanvas="always">
            </app-products-view> -->

            <app-products-view [productsCount]="productsCount" [products]="products" [layout]="viewMode" offcanvas="always"></app-products-view>
        </div>
        <div class="empty-state" *ngIf="products?.length == 0 || categoryData?.sucategories?.length == 0;">
            <img src="/assets/svg/empty_state.svg">
            <h4 class="mt-4">Selected Category has No Products.</h4>
        </div>
        <app-shop-sidebar offcanvas="always"></app-shop-sidebar>
    </div>
</ng-container>